// extracted by mini-css-extract-plugin
export default {"products":"gA-z","card":"hA-z","oosMessaging":"iA-z"};